// src/hooks/useAgentHistory.js
// FASE 1: busca a decisão mais recente do agent_apollo_context_harvester_v1
// para uma empresa. Usado para mostrar banner de "agente já classificou"
// antes de o humano fazer override via hint manual.
//
// Retorna:
//   null              → agente ainda não analisou essa empresa
//   { recommendation: 'skip' | 'enrich', confidence, reasoning, created_at, skip_reason? }

import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

export function useAgentHistory(empresaId) {
  const [lastDecision, setLastDecision] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!empresaId) { setLastDecision(null); return; }
    let cancelled = false;
    setLoading(true);

    (async () => {
      const { data, error } = await supabase
        .from('ai_evidence')
        .select('suggested_value, reasoning, confidence, created_at, metadata')
        .eq('entity_type', 'company')
        .eq('entity_id', empresaId)
        .eq('agent', 'apollo_context_harvester_v1')
        .order('created_at', { ascending: false })
        .limit(1);

      if (cancelled) return;
      if (error || !data || data.length === 0) {
        setLastDecision(null);
      } else {
        const ev = data[0];
        const rec = ev.suggested_value?.recommendation;
        setLastDecision({
          recommendation: rec,
          confidence: ev.confidence,
          reasoning: ev.reasoning,
          skip_reason: ev.suggested_value?.skip_reason,
          created_at: ev.created_at,
        });
      }
      setLoading(false);
    })();

    return () => { cancelled = true; };
  }, [empresaId]);

  return { lastDecision, loading };
}
